export default {
	logo: "/img/apex-logo.svg",
	paymentKey: "pk_live_IpU2h4vw6L2N2iIvLeJqJnr3",
	cssVariables: {
		"--color1": "#111319",
		"--color2": "#e9bb2b",
		"--color3": "hsl(0, 67%, 55%)",
		"--color4": "#e9bb2b"
	}
}
